<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'系统配置'},{name:'角色权限管理',goback:true},{name:'分配权限'}]" :title="'分配权限'"/>
            <!-- 表单 -->
            <div class="box">
                 <div class="forms">
                    <div class="child">
                        <div class="name">角色名称：</div>
                        <div class="content">{{autName}}</div>
                    </div>
                    <div class="child">
                        <div class="name">权限配置：</div>
                        <div class="content">
                            <div class="tree">
                            <el-card class="box-card cardLeft">
                                <div slot="header" class="clearfix">
                                    <span>菜单权限设置</span>
                                </div>
                                <el-tree
                                    :empty-text="'暂无权限'"
                                    show-checkbox
                                    node-key="id"
                                    :default-checked-keys="treeCheck"
                                    highlight-current
                                    :data="treeList"
                                    ref="tree"
                                    >
                                    <span class="custom-tree-node" slot-scope="{ node, data }">
                                        <span>{{ data.permissionName }}</span>
                                    </span>
                                </el-tree>
                                
                            </el-card>
                            <!-- <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>功能权限设置</span>
                                </div>
                                <el-checkbox v-model="checkAll " :indeterminate="isIndeterminate" @change="handleCheckAllChange" v-show="checkList.length>0">全选</el-checkbox>
                                <el-checkbox-group v-model="checkResult" @change="handleCheckedCitiesChange">
                                    <el-checkbox v-for="(item,index) in checkList" :label="item.id" :key="index">{{item.permissionName}}</el-checkbox>
                                </el-checkbox-group>
                            </el-card> -->
                    </div>
                        </div>
                    </div>
                    
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                            <div class="doubleBtn">
                              <el-button size="small" type="primary" @click="submit">确认</el-button>
                              <el-button size="small" @click="cancel">取消</el-button>
                          </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        breadcrumb,
    },
    data(){
        return{
            id:void 0,
            sendInfoTwo:{
                id:null,//角色id
                roleName:null,//角色名称：
                roleCode:null,//角色编码
                remarks:null,//描述
            },//编辑提交数据
         
            editor:null,//富文本编辑器容器
            autName:'',//管理员名称
            autId:'',//权限id

            treeList: [],//左边树状数组
            checkList:[],//右边多选框数组
            isIndeterminate:false,//全选样式
            checkAll :false,//全选
            checkResult:[],//右边多选框触发数据选中
            treeCheck:[],//点击右边使左边父元素被选中 左边被选中数据赋值
            currentIndex:null,//当前右边数组所属父级最顶层顺序 用以全选时递归当前顺序的数组而不递归整个数
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
    },
    vuerify: {
        'sendInfoTwo.roleName':{
            test:'realName',
            message:'角色名称错误'
        },
        'sendInfoTwo.roleCode':{
            test:/^[A-Za-z]{1,50}$/,
            message:'角色编码错误'
        }
    },
    methods:{
      
		getDetail(id){
			this.$axiosz.get('backstage/sysPermission/roleId/'+id).then((r)=>{
			    if(r.code==200){
                    
                    this.autId=id;
                    // this.treeList = r.data
                    this.treeList=this.buildTree(r.data);
                    this.setAut(this.treeList);
                    }else{
                        this.$alert(r.msg)
                    }
			})
		},
    getRoleName(id){
      this.$axiosz.get('backstage/sysRole/view/'+id).then((r)=>{
                if(r.code==200){
                    this.autName=r.data.roleName;
                }else{
                    this.$alert(r.msg)
                }
            })
    },
        cancel(){
            this.treeList= [];//左边树状数组
            this.checkList=[];//右边多选框数组
            this.isIndeterminate=false;//全选样式
            this.checkAll=false;//全选
            this.checkResult=[];//右边多选框触发数据
            this.treeCheck=[];//点击右边使左边父元素被选中 左边被选中数据赋值
           this.$router.back(-1)
        },
        //权限保存按钮
        submit:function(){
            // console.log(this.$refs.tree.getCheckedKeys(),this.$refs.tree.getHalfCheckedKeys()); //左边 已选中 和 半选中
            // console.log(this.$refs.tree.getHalfCheckedKeys) ; //复选框当前数据
            // console.log(this.$refs.tree.getCheckedKeys())
            // console.log(1111111111)
            // console.log(...this.$refs.tree.getHalfCheckedKeys())
            let endArr = [];
            if(this.$refs.tree.getHalfCheckedKeys()){
                endArr=[...this.$refs.tree.getCheckedKeys(),...this.$refs.tree.getHalfCheckedKeys()];
            }else{
                endArr=[...this.$refs.tree.getCheckedKeys()];
            }
            let formData = new FormData();
            for(let item of endArr){
                formData.append("ids",item);
            }
            console.log(endArr.length)
            this.$axiosz.post('backstage/sysRole/permission/'+this.autId,formData).then((r)=>{
                if(r.code==200){
                    this.$message({
                        type: 'success',
                        message: '设置权限成功!'
                    });
                    this.getData();
                    this.cancels();
                }else{
                    this.$alert(r.msg)
                }
            })
        },
        //数据去重
        deweight:function(arr){
            let i,
            obj = {},
            result = [],
            len = arr.length;
            for(i = 0; i< arr.length; i++){
                if(!obj[arr[i]]){ //如果能查找到，证明数组元素重复了
                    obj[arr[i]] = 1;
                    result.push(arr[i]);
                }
            }
            return result;
        },
        //建立数组树结构 菜单权限设置
        buildTree(list){
            for(let i = 0 ,len = list.length ; i < len ; i++){
                // if(list[i].type==1 && list[i].sysPermissionVoList &&list[i].sysPermissionVoList[0].type==2) continue;
                list[i].lable=list[i].permissionName
                if(list[i].sysPermissionVoList && list[i].sysPermissionVoList.length > 0){
                    list[i].children=list[i].sysPermissionVoList
                }
                if(list[i].sysPermissionVoList && list[i].sysPermissionVoList.length > 0){
                    this.buildTree(list[i].sysPermissionVoList);
                }
                if(list[i].type == 2){
                    list[i].permissionName =  list[i].permissionName + '-按钮'
                }
            }
            return list;
        },
        //递归父级id
        recursion:function(list,id,lists){
            for(let item of list){
                if(item.id===id && item.type!=0 && item.type!=1){
                    if(this.treeCheck.indexOf(item.parentId) < 0){
                        this.treeCheck.push(item.parentId);
                    }
                }else if(item.sysPermissionVoList && item.sysPermissionVoList.length>0){
                        this.recursion(item.sysPermissionVoList,id,lists);
                }
            }
            return this.treeCheck;
        },
        recursionDelete:function(list,id,lists,parentId){
            list.forEach((item,n) => {
                if(item.id==id && item.type!=0 && item.type==2){
                    if(parentId){
                        if(this.treeCheck.indexOf(parentId) > -1){
                            this.treeCheck.splice(this.treeCheck.indexOf(parentId),1)
                        }
                    }
                }else if(item.sysPermissionVoList && item.sysPermissionVoList.length>0){
                        this.recursionDelete(item.sysPermissionVoList,id,lists,item.id);
                }
            })
            return this.treeCheck;
        },
        //获取权限回显
        setAut:function(list){
            for(let item of list){
                if(item.isSelected==1 && !item.sysPermissionVoList){
                    this.treeCheck.push(item.id); //将左边最后一级赋值选中 插件自动将父级半选中 提交可获取
                    this.treeCheck=this.deweight(this.treeCheck);
                }
                if(item.sysPermissionVoList && item.sysPermissionVoList.length > 0){
                    this.setAut(item.sysPermissionVoList);
                }
                
                // if(item.type  == 0  && !item.sysPermissionVoList){
                //     if(item.isSelected==1){
                //         this.treeCheck.push(item.id); //将左边最后一级赋值选中 插件自动将父级半选中 提交可获取
                //         this.treeCheck=this.deweight(this.treeCheck);
                //     }
                // }
                // if(item.type==1 && item.sysPermissionVoList && item.sysPermissionVoList.length > 0){
                //     if(item.sysPermissionVoList[0].type==2){
                //         if(item.isSelected==1){
                //             this.treeCheck.push(item.id); //将左边最后一级赋值选中 插件自动将父级半选中 提交可获取
                //             this.treeCheck=this.deweight(this.treeCheck);
                //         }
                //         // for(let items of item.sysPermissionVoList){
                //         //     if(items.isSelected===1){
                //         //         this.checkResult.push(items.id);//将右边复选框的选中项选中
                //         //     }
                //         // }
                //     }else{
                //         this.setAut(item.sysPermissionVoList,lists);
                //     }
                // }else if(item.type!=1 && item.sysPermissionVoList && item.sysPermissionVoList.length>0){
                //     this.setAut(item.sysPermissionVoList,lists);
                // }
            }
        },
        //点击树的复选框删除右边 对应的选中项
        delCheck:function(obj){
            if(obj.type==1 && obj.sysPermissionVoList && obj.sysPermissionVoList.length>0){
                if(obj.sysPermissionVoList[0].type==2){
                    this.checkResult=this.deleteBouth(this.checkResult,obj.sysPermissionVoList);
                }else{
                    for(let item of obj.sysPermissionVoList){
                        this.delCheck(item);
                    }
                }
                if(obj.sysPermissionVoList[0].id==this.checkList[0].id){
                    this.checkAll=false;
                    this.isIndeterminate=false;
                }
            }else if(obj.type!=1 && obj.sysPermissionVoList && obj.sysPermissionVoList.length>0){
                for(let item of obj.sysPermissionVoList){
                    this.delCheck(item);
                }
            }
        },
        // 删除两个数组的相同值 取前一个数组删除后结果
        deleteBouth:function(arr1,arr2){
            arr1= arr1.filter(item => {
                let idList= arr2.map(v => v.id)
                return !idList.includes(item)
            })
            return arr1;
        },
    },
    mounted(){
        // this.editor = new wangEditor(this.$refs.wangEditor);
        // this.editor.customConfig.onchange =  (html) => { //通过富文本变化赋值
        //     // html 即变化之后的内容
        //     this.sendInfo.content=html;
        //     this.$vuerify.check(['sendInfo.content']);
        // }
        // this.editor.create();
    },
	created() {
    const {id} = this.$route.params
    this.id= id || void 0
		if(id){
		    this.sendInfoTwo.id=id;
        this.getRoleName(id)
			  this.getDetail(id);
		}
	}
}
</script>

<style lang="scss" scoped>
.warp{
     height:93%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
      padding:100px 0;
        .forms{
            max-width: 610px;
            margin: auto;
            transform: translateX(-100px);
            .child{
                .name{
                  width:80px;
                  text-align: right;
                  margin-right:10px;
                }
                .content{
                    flex: 1;
                    /deep/ .ql-container{
                      min-height: 410px;
                    }
                    /deep/ .custom-tree-node{
                      margin-left:8px;
                    }
                }
            }
        }
    }
}
</style>
